<a class="nav__item" [ngClass]="css">
  <ng-content></ng-content>
</a>
